import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import CategoryTabs from '@/components/base/CategoryTabs';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';
import { categoryMap, categories } from '@/mocks/categories';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categoryName = slug ? categoryMap[slug] : undefined;
  const filteredArticles = slug
    ? articles.filter((a) => a.category === slug)
    : articles;

  const activeCategory = categories.find((c) => c.slug === slug);

  if (slug && !categoryName) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen pt-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">分类未找到</h1>
            <p className="text-foreground-600 mb-6">你访问的分类页面不存在。</p>
            <Link to="/" className="text-primary-600 hover:text-primary-700 font-label text-sm cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
            <Breadcrumb
              items={slug ? [{ label: categoryName || slug }] : []}
            />
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              {slug ? categoryName : '全部文章'}
            </h1>
            {activeCategory && (
              <p className="text-foreground-600 text-sm md:text-base mb-6">
                {activeCategory.description}
              </p>
            )}
            <CategoryTabs activeSlug={slug} />
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
          {filteredArticles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <p className="text-foreground-600 text-lg mb-4">该分类下暂无文章</p>
              <Link to="/" className="text-primary-600 hover:text-primary-700 font-label text-sm cursor-pointer">返回首页</Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        'name': slug ? `${categoryName} - 人渣游戏深度解析` : '全部文章 - 人渣游戏深度解析',
        'description': activeCategory?.description || '人渣游戏相关文章分类列表',
        'url': `https://scum-game-analysis.com/category/${slug || ''}`,
        'inLanguage': 'zh-CN',
        'breadcrumb': {
          '@type': 'BreadcrumbList',
          'itemListElement': [
            { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'https://scum-game-analysis.com/' },
            { '@type': 'ListItem', 'position': 2, 'name': categoryName || '全部文章' },
          ],
        },
      }) }} />
    </>
  );
}